import { defineComponent as Z, useSlots as q, computed as C, useTemplateRef as E, ref as v, watchEffect as G, onMounted as H, onBeforeUnmount as J, createElementBlock as y, openBlock as d, Fragment as Q, createVNode as p, renderSlot as f, unref as r, withCtx as k, Transition as N, createBlock as W, createCommentVNode as g, withModifiers as P, normalizeClass as h, mergeProps as R, withDirectives as X, normalizeProps as u, guardReactiveProps as c, createElementVNode as Y, toDisplayString as _, nextTick as D } from "vue";
import { RevBackdrop as ee } from "@ds/components/Backdrop";
import { RevButtonIcon as te } from "@ds/components/ButtonIcon";
import { RevPortal as oe } from "@ds/components/Portal";
import { vFocus as ae } from "../../directives/focus.js";
import le from "../../icons/generated/IconCross.vue2.js";
import { useI18n as se } from "@ds/plugin";
import ne from "../../translations/generic.translations.js";
import { tw as o } from "../../utils/tailwind.js";
import { defaultModalTransitionClasses as re } from "./ModalBase.constant.js";
import { onModalUpdate as ie, isModalOpened as I, openModal as de, closeModal as fe } from "./ModalBase.helpers.js";
const ue = ["aria-label"], ce = {
  key: 0,
  class: "text-static-default-hi body-1"
}, Me = /* @__PURE__ */ Z({
  name: "RevModalBase",
  inheritAttrs: !1,
  __name: "ModalBase",
  props: {
    name: {},
    title: { default: "" },
    closeButtonLabel: { default: () => {
    } },
    hasPadding: { type: Boolean, default: !0 },
    backdropZIndex: { default: "z-10" },
    backdropBackgroundColor: { default: () => {
    } },
    backgroundColor: { default: "mid" },
    transitionClassNames: { default: () => re },
    hasBodyOverflow: { type: Boolean, default: !0 },
    to: { default: "body" },
    defer: { type: Boolean, default: !1 },
    disableCloseOnBackdropClick: { type: Boolean, default: !1 }
  },
  emits: ["open", "close"],
  setup(a, { emit: O }) {
    const m = q(), M = O, S = C(() => [
      m.body && o`fixed bottom-0 left-0 flex max-h-dvh w-full flex-col justify-between`,
      m.body && {
        mid: o`bg-surface-default-mid`,
        low: o`bg-surface-default-low`
      }[a.backgroundColor]
    ]), z = C(
      () => m.body && [
        o`relative mx-24 mt-16`,
        a.title ? [
          o`flex items-center justify-center px-40 pb-20 pt-8 text-center after:border-static-default-low after:absolute after:bottom-0 after:border-b after:content-['']`,
          a.hasPadding ? o`after:inset-x-0` : o`after:-inset-x-24`
        ] : o`h-52`
      ]
    ), A = C(
      () => m.body && [
        o`grow`,
        a.hasBodyOverflow ? o`overflow-auto` : o`overflow-hidden`,
        a.hasPadding && [o`p-24`, !a.title && o`pt-0`]
      ]
    ), L = se(), U = a.closeButtonLabel || L(ne.buttonClose), V = E("close-button");
    async function j() {
      var e;
      await D(), await D(), (e = V.value) == null || e.$el.focus();
    }
    const w = v(), s = v(!1), b = v(!1);
    G(async () => {
      s.value && await j();
    });
    const B = v(), $ = (e) => {
      B.value = e == null ? void 0 : e.target, de(a.name);
    }, l = (e) => {
      var t;
      fe(
        a.name,
        e && "cause" in e ? e : void 0
      ), (t = B.value) == null || t.focus(), B.value = void 0;
    };
    function F(e) {
      s.value = e.opened, window.document.body.style.overflow = s.value ? "hidden" : "", s.value ? M("open") : M("close", e == null ? void 0 : e.closingEvent);
    }
    function K(e) {
      const { key: t, shiftKey: i, target: T } = e;
      if (t === "Escape") {
        l({ cause: "dismiss" });
        return;
      }
      if (w.value && t === "Tab") {
        const n = w.value.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (n.length < 2) {
          e.preventDefault();
          return;
        }
        const x = n.length - 1;
        i === !1 && T === n[x] ? (e.preventDefault(), n[0].focus()) : i === !0 && T === n[0] && (e.preventDefault(), n[x].focus());
      }
    }
    return H(() => {
      ie(a.name, F), I(a.name) && $();
    }), J(() => {
      I(a.name) && l();
    }), (e, t) => (d(), y(Q, null, [
      p(r(oe), {
        defer: e.defer,
        to: e.to
      }, {
        default: k(() => [
          p(N, {
            appear: "",
            "enter-active-class": "motion-safe:transition-opacity motion-safe:duration-300",
            "enter-from-class": "opacity-0",
            "leave-active-class": "motion-safe:transition-opacity motion-safe:duration-200",
            "leave-to-class": "opacity-0"
          }, {
            default: k(() => [
              s.value ? (d(), W(r(ee), {
                key: 0,
                "background-color": e.backdropBackgroundColor,
                class: h(e.backdropZIndex),
                onClick: t[3] || (t[3] = P(
                  () => b.value ? null : l({
                    cause: "backdropClick",
                    disabled: e.disableCloseOnBackdropClick
                  }),
                  ["self"]
                )),
                onMousedown: t[4] || (t[4] = P((i) => b.value = !1, ["self"]))
              }, {
                default: k(() => [
                  p(N, R({ appear: "" }, e.transitionClassNames), {
                    default: k(() => [
                      s.value ? X((d(), y("div", R({ key: 0 }, e.$attrs, {
                        ref_key: "dialog",
                        ref: w,
                        "aria-label": e.title,
                        "aria-modal": "true",
                        class: S.value,
                        role: "dialog",
                        tabindex: "0",
                        onKeydown: K,
                        onMousedown: t[1] || (t[1] = (i) => b.value = !0),
                        onMouseup: t[2] || (t[2] = (i) => b.value = !1)
                      }), [
                        f(e.$slots, "default", u(c({ close: l })), () => [
                          Y("div", {
                            class: h(z.value)
                          }, [
                            f(e.$slots, "beforeTitle", u(c({ close: l }))),
                            e.title ? (d(), y("h2", ce, _(e.title), 1)) : g("", !0),
                            f(e.$slots, "afterTitle", u(c({ close: l })), () => [
                              p(r(te), {
                                ref: "close-button",
                                "alternative-text": r(U),
                                class: "absolute right-0 top-0",
                                icon: r(le),
                                variant: "secondary",
                                onClick: t[0] || (t[0] = () => l({ cause: "dismiss" }))
                              }, null, 8, ["alternative-text", "icon"])
                            ])
                          ], 2),
                          e.$slots.body ? (d(), y("div", {
                            key: 0,
                            class: h(A.value)
                          }, [
                            f(e.$slots, "body", u(c({ close: l })))
                          ], 2)) : g("", !0)
                        ])
                      ], 16, ue)), [
                        [r(ae), !0]
                      ]) : g("", !0)
                    ]),
                    _: 3
                  }, 16)
                ]),
                _: 3
              }, 8, ["background-color", "class"])) : g("", !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["defer", "to"]),
      f(e.$slots, "trigger", u(c({ open: $ })))
    ], 64));
  }
});
export {
  Me as default
};
